import api from './api';

/**
 * Opções de usuário para seletores. `includeBots` traz também os usuários
 * robô (bot de conexão MCP) — use só onde o bot participa de verdade, como o
 * seletor de membros do chat interno; nos seletores de atendente ele fica de
 * fora.
 */
export const getUserOptions = ({ includeBots = false } = {}) =>
  api.get('/users/options', { params: includeBots ? { includeBots: 1 } : {} });
export const getUsers = (params) => api.get('/users/', { params });
export const getUsersList = () => api.get('/users/list');
export const getUser = (id) => api.get(`/users/${id}`);
export const getMyProfile = () => api.get('/users/profile');
export const updateMyProfile = (data) => api.put('/users/profile', data);
export const uploadProfileAvatar = (file) => {
  const formData = new FormData();
  formData.append('profileImage', file);
  return api.post('/users/profile/avatar', formData);
};
export const createUser = (data) => api.post('/users', data);
export const updateUser = (id, data) => api.put(`/users/${id}`, data);
export const getAppointments = (params) => api.get('/appointments', { params });
export const deleteUser = (id) => api.delete(`/users/${id}`);
export const getCompany = (id) => api.get(`/companies/${id}`);
export const getCompaniesList = () => api.get('/companies/list');
